<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	data() {
		return {
			maxNumberOfList: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label:
						"In completing this questionnaire, are you acting on the instructions of a third party?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasThidPartyInstructions`,
					props: {
						suggest: {
							typeIncludes: `hasThidPartyInstructions`
						},
						createOptions: {
							type: `hasThidPartyInstructions`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Name of individual, company or organization",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyName`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyName`
						},
						createOptions: {
							type: `thirdPartyName`,
							dataType: "string"
						}
					}
				},
				{
					label: "Date of Birth (for an individual)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyDOB`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyDOB`
						},
						createOptions: {
							type: `thirdPartyDOB`,
							dataType: "date"
						}
					}
				},
				{
					label: "Incorporation number (for a corporation) ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyINCNo`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyINCNo`
						},
						createOptions: {
							type: `thirdPartyINCNo`,
							dataType: "string"
						}
					}
				},
				{
					label: "Jurisdiction of registration (for a corporation)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyJurisdictionOfRegistration`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyJurisdictionOfRegistration`
						},
						createOptions: {
							type: `thirdPartyJurisdictionOfRegistration`,
							dataType: "string"
						}
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0thirdPartyPrimaryAddress",
					props: {
						suggest: {
							typeIncludes: "thirdPartyPrimaryAddress"
						},
						createOptions: {
							type: "thirdPartyPrimaryAddress"
						}
					}
				},
				{
					label:
						"Principal business or occupation of this individual, company or organization",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyBusinessOrOccupation`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyBusinessOrOccupation`
						},
						createOptions: {
							type: `thirdPartyBusinessOrOccupation`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Relationship of this individual, company or organization to you",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyRelationship`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyRelationship`
						},
						createOptions: {
							type: `thirdPartyRelationship`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
